
export const carrierConstants = {
  GET_CARRIERS_REQUEST: 'GET_CARRIERS_REQUEST',
  GET_CARRIERS_SUCCESS: 'GET_CARRIERS_SUCCESS',
  GET_CARRIERS_FAILURE: 'GET_CARRIERS_FAILURE',

  GET_CARRIER_REQUEST: 'GET_CARRIER_REQUEST',
  GET_CARRIER_SUCCESS: 'GET_CARRIER_SUCCESS',
  GET_CARRIER_FAILURE: 'GET_CARRIER_FAILURE',

  ADD_CARRIER_REQUEST: 'ADD_CARRIER_REQUEST',
  ADD_CARRIER_SUCCESS: 'ADD_CARRIER_SUCCESS',
  ADD_CARRIER_FAILURE: 'ADD_CARRIER_FAILURE',

  ADD_BULK_CARRIER_REQUEST: 'ADD_BULK_CARRIER_REQUEST',
  ADD_BULK_CARRIER_SUCCESS: 'ADD_BULK_CARRIER_SUCCESS',
  ADD_BULK_CARRIER_FAILURE: 'ADD_BULK_CARRIER_FAILURE',

};
